export default class {
    _id;
    _name;
    _isHead;
    _address;
    _organization;
    _createdOn;
    _regions;
    _contractNumber
    _contractDateFrom
    _contractDateTo
    _contractSum
    _sumForMail
    _sumForOverPaged
    _isActive

    get id() {
        return this._id
    }

    set id(value) {
        this._id = value
    }


    get name() {
        return this._name
    }

    set name(value) {
        this._name = value
    }

    get isHead() {
        return this._isHead
    }

    set isHead(value) {
        this._isHead = value
    }

    get address() {
        return this._address;
    }

    set address(value) {
        this._address = value;
    }

    get organization() {
        return this._organization
    }

    set organization(value) {
        this._organization = value
    }

    get createdOn() {
        return this._createdOn
    }

    set createdOn(value) {
        this._createdOn = value
    }

    get contractNumber() {
        return this._contractNumber
    }

    set contractNumber(value) {
        this._contractNumber = value
    }
    get contractDateFrom() {
        return this._contractDateFrom
    }

    set contractDateFrom(value) {
        this._contractDateFrom = value
    }
    get contractDateTo() {
        return this._contractDateTo
    }

    set contractDateTo(value) {
        this._contractDateTo = value
    }
    get contractSum() {
        return this._contractSum
    }

    set contractSum(value) {
        this._contractSum = value
    }
    get sumForMail() {
        return this._sumForMail
    }

    set sumForMail(value) {
        this._sumForMail = value
    }
    get sumForOverPaged() {
        return this._sumForOverPaged
    }

    set sumForOverPaged(value) {
        this._sumForOverPaged = value
    }


    get isActive() {
        return this._isActive
    }

    set isActive(value) {
        this._isActive = value
    }

    get regions() {
        return this._regions;
    }

    set regions(value) {
        this._regions = value;
    }
}